export var formMessageStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'block',
      paddingLeft: v.paddingLeft
    }, p.error && {
      color: v.colorScheme.red.foreground
    });
  }
};
//# sourceMappingURL=formMessageStyles.js.map
